import { z } from 'zod'

/**
 * Theme là whitelist token, KHÔNG phải CSS tự do.
 *
 * Lý do an ninh: partner gửi được chuỗi CSS bất kỳ thì dựng được overlay giả lên nút "Ký hợp đồng"
 * (phishing), hoặc chèn `url()` gọi ra ngoài. Nên mọi giá trị phải khớp regex hẹp tại đây;
 * cái gì không parse được thì rơi về preset default, không escape rồi cho qua.
 */
export const HexColor = z.string().regex(/^#[0-9a-fA-F]{6}$/, 'phải là hex 6 ký tự, ví dụ #7C5CFF')
export const PxRadius = z.string().regex(/^(0|[1-9]\d{0,2})px$/, 'phải dạng "12px", tối đa 999px')

export const Theme = z.object({
  brand_color: HexColor,
  secondary_color: HexColor.optional(),
  on_primary: HexColor.optional(),
  radius: PxRadius.default('12px'),
  /** id của logo đã upload & sanitize, self-host. Không nhận URL ngoài (SSRF / mixed content). */
  logo_id: z.string().regex(/^[a-z0-9_-]{1,40}$/).nullable().default(null),
  mode: z.enum(['light']).default('light'),
  font: z.enum(['system']).default('system'),
})
export type Theme = z.infer<typeof Theme>

export const DEFAULT_THEME: Theme = {
  brand_color: '#EF6820',
  secondary_color: '#EE46BC',
  on_primary: '#FFFFFF',
  radius: '12px',
  logo_id: null,
  mode: 'light',
  font: 'system',
}
